// extracted by mini-css-extract-plugin
module.exports = {"cover":"b_b"};